/* eslint-disable no-undef */
import React from "react";
import { MDBBadge } from "mdbreact";
import PropTypes from "prop-types";
import { GGgetMode } from "../../services/gglocalstorage";
import { ConvertModalidadeToDisplay } from "../../helpers/Formatters";

export default function BadgeSelected({ tipo, modalidade }) {
	BadgeSelected.propTypes = {
		tipo: PropTypes.string.isRequired,
		modalidade: PropTypes.string.isRequired,
	};

	return (
		<h4>
			<MDBBadge color={GGgetMode() ? "primary" : "secondary"} size="2x">
				{`${ConvertModalidadeToDisplay(tipo)} - ${
					ConvertModalidadeToDisplay(modalidade) === "Híbrido"
						? "Presencial"
						: ConvertModalidadeToDisplay(modalidade)
				}`}
			</MDBBadge>
		</h4>
	);
}
